export default "__VITE_ASSET__Vz_gHZaP__"